import { DOCUMENT } from '@angular/common';
import { inject, Injectable } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router } from '@angular/router';
import { AppBootstrapStore } from '@umss/shared/core';
import { filter, first, switchMap, take } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UmssSplashScreenService {
  private _document = inject(DOCUMENT);
  private _router = inject(Router);
  private appBoostrap = inject(AppBootstrapStore);

  private _ready$ = toObservable(this.appBoostrap.ready);

  /**
   * Constructor
   */
  constructor() {
    // Hide it on the first NavigationEnd event
    this._router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        take(1),
        switchMap(() =>
          this._ready$.pipe(
            filter((ready) => ready === true),
            first()
          )
        )
      )
      .subscribe(() => {
        this.hide();
      });
  }

  /**
   * Show the splash screen
   */
  show(): void {
    this._document.body.classList.remove('umss-splash-screen-hidden');
  }

  /**
   * Hide the splash screen
   */
  hide(): void {
    this._document.body.classList.add('umss-splash-screen-hidden');
  }
}
